import React from 'react';
import PropTypes from 'prop-types';
import {FEATURED} from '../../constants';
import {FiltersContextProvider} from '../../contexts/FiltersContext';
import {ContentContextProvider} from '../../contexts/ContentContext';

/**
 * A simple wrapper to provide the filters and content context to a content driven PLP.
 */
const ContentWrapper = ({children, includeFiltersProvider = false}) => {
  if (includeFiltersProvider) {
    return (
      <FiltersContextProvider defaults={{sort: [FEATURED]}}>
        <ContentContextProvider>{children}</ContentContextProvider>
      </FiltersContextProvider>
    );
  }

  return <ContentContextProvider>{children}</ContentContextProvider>;
};

export default ContentWrapper;

ContentWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  includeFiltersProvider: PropTypes.bool,
};
